import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import Seo from "../components/seo"
import Layout from "../components/layout"
import Button from "../components/Button"
import Header from "../components/header"

const Code = () => {
  return (
    <>
      <Seo title="enter code" />

      <Header />

      <section className="bg-[url(images/bg-mountains.png)] bg-opacity-10 h-screen">
        <div className="bg-white opacity-90 w-full h-full flex flex-col items-center justify-center">
          <form className="flex flex-col items-center justify-center w-[31.6%] h-full">
            <input
              className="border-b-[1px] border-b-black py-2 w-full font-ubuntu text-[14px] font-light text-black mb-8"
              type="text"
              placeholder="Enter your code"
            />
            <Button color="blue" size="xs">
              Send
            </Button>
          </form>
        </div>
      </section>
    </>
  )
}

export default Code
